import React from 'react';
import { connect } from 'react-redux';
import { createActions } from '../../../store';
import SwitchListItem from '../../../../../list-items/SwitchListItem/SwitchListItem';

const VisualizerInvertListItem = (props) => {
    const { visualizerInverted, updateVisualizerSettings } = props;
    const onInvertChange = (event) => updateVisualizerSettings({ inverted: event.target.checked });
    
    return (
        <SwitchListItem
            text='Invert Spectrum'
            checked={visualizerInverted}
            onChange={onInvertChange}
        />
    );
};

const mapStateToProps = (state) => {
    const { inverted: visualizerInverted } = state.createPreview.present.videoSettings.visualizer;
    return { visualizerInverted };
}

const mapDispatchToProps = (dispatch) => {
    const updateVisualizerSettings = (properties) => dispatch(createActions.updateVisualizerSettings(properties));
    return { updateVisualizerSettings }
}

export default connect(mapStateToProps, mapDispatchToProps)(VisualizerInvertListItem);